import * as AlertEffects from './alerts.effect';

export const effects = { ...AlertEffects };
